import createReducer from '../utils/createReducer';
import guestSelectorActions from '../actions/guestSelectorActions';
import GuestSelectorRecord from '../records/guestSelectorRecord';

const initialState = new GuestSelectorRecord();

const actionHandlers = {
    [guestSelectorActions.UPDATE_GUEST_SELECTOR](state, {payload = {}}) {
        const {fieldsChanged} = payload;

        return state.merge(fieldsChanged);
    }
};

export default createReducer(actionHandlers, initialState);
